<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col class="mb-2 text-left">
        <p style="color: #0069A9; font-weight: 600; text-align: left" class="m-3">Directorio</p>
        <div class="text-center" v-if="loaderDirectorio">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>

        <ul class="padding-ul">
          <li v-for="(ruta,index) in listaRutasPadres" :key="index"
          >
            <span  class="directorio" @click="obtenerRutasHija(ruta.idRuta, index, 'collapseRutaPadre-')"
                  v-bind:class="{'folder-principal': ruta.idRuta === validacionRutaPadre,}" style="cursor: pointer">
              <font-awesome-icon :icon="['fas', 'folder']"  style="color: #0E6BA9; cursor: pointer"/>
              {{ruta.nombreRuta}}
              <span class="chevron-folder">
                    <b-icon icon="chevron-down" v-b-toggle="'collapseRutaPadre-'+index" style="cursor: pointer"
                                         :rotate="rotarChevron['collapseRutaPadre-'+index] ? 180 : 0"
                    ></b-icon>
              </span>
            </span>
              <ul style="padding-left: 21px;">
                <li  v-for="(rutaHija, i) in listaRutasHijas" :key="i">
                  <span  class="directorio" v-if="ruta.idRuta === rutaHija.idRutaPadre" style="cursor: pointer"
                         @click="obtenerPathHija(rutaHija.path, rutaHija.idRuta,  'collapseRutaHija-',i)"
                         v-bind:class="{'folder-secundario': rutaHija.idRuta === validacionRutaHija,}">
                    <font-awesome-icon :icon="['fas', 'folder-open']" style="color: #299fbc; cursor: pointer" />
                    {{ rutaHija.nombreRuta}}
                     <span class="chevron-folder">
                     <b-icon icon="chevron-down" v-b-toggle="'collapseRutaHija'+i" style="cursor: pointer"
                             :rotate="rotarChevronHija['collapseRutaHija-'+i] ? 180 : 0"
                     ></b-icon>
                             </span>
                  </span>
                </li>
              </ul>
          </li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "DirectorioEce",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    listaRutasPadres: [],
    listaRutasHijas: [],
    validacionRutaPadre: 0,
    validacionRutaHija: 0,
    acumulador: 0,

    rotarChevron : [],
    rotarChevronHija : [],
    loaderDirectorio: false

  }),
  created(){
    this.debug = this.$localStorageService.getDebug();

    this.obtenerRutasPadre();
  },
  methods:{
    obtenerRutasPadre() {
      this.loaderDirectorio = true
      const params = {
        idClinica: this.$localStorageService.getIdClinica(),
      }
      this.$http
          .post(this.$api + "rutaExpediente/listarRutasPadre", params)
          .then((response) => {
            this.listaRutasPadres = response.data.data;
          })
          .finally(() => {
            this.loaderDirectorio = false;
          });
    },
    obtenerRutasHija(idRutaPadre, index, clase) {
    this.rotar(clase, index);
      this.validacionRutaPadre = idRutaPadre;
      const params = {
                idRutaPadre: idRutaPadre
            }
      this.$http
          .post(
              this.$api +
              "rutaExpediente/listarRutasHijas", params  )
          .then((response) => {
            this.listaRutasHijas = response.data.data;
          })
          .finally(() => {
            this.validaCarpeta();
          });
    },
    obtenerPathHija(rutaHija, idRutaHija, clase, index) {
      this.rotarHija(clase, index);
      this.$emit("ruta", rutaHija);
      this.validacionRutaHija = idRutaHija;
    },
    validaCarpeta() {
      if (this.acumulador !== 0) {
        this.listaRutasHijas = [];
        this.acumulador = 0;
        this.validacionRutaPadre = 0;
        this.validacionRutaPadre = 0;

      }else{
        this.acumulador++;
      }
    },

    rotar(id, index) {
      let idChevron = id + index;
      this.$set(this.rotarChevron, idChevron, !this.rotarChevron[idChevron]);
    },
    rotarHija(id, index) {
      let idChevron = id + index;
      this.rotarChevronHija = [];
      this.$set(this.rotarChevronHija, idChevron, !this.rotarChevronHija[idChevron]);
    },

  },
}
</script>

<style scoped>
@media only screen and (max-width: 900px) {
  .directorio {
    font-size: small !important;
  }
  .padding-ul{
    padding-left: 5px !important;
  }
}
.chevron-folder{
  margin-right: 5px !important;
}
.chevron-folder{
  float: right;
}
.padding-ul{
  padding-left: 21px;
}
</style>
